// Code generated by go generate; DO NOT EDIT.

export const supportedDatasources = new Set<string>([
  '__expr__',
  'aggregations-io-datasource',
  'apache-iotdb-datasource',
  'aquaqanalytics-kdbbackend-datasource',
  'axiomhq-axiom-datasource',
  'cloudwatch',
  'cnos-cnosdb-datasource',
  'datasource',
  'dlopes7-appdynamics-datasource',
  'dvelop-odata-datasource',
  'elasticsearch',
  'frser-sqlite-datasource',
  'grafadruid-druid-datasource',
  'grafana-athena-datasource',
  'grafana-azure-data-explorer-datasource',
  'grafana-azure-monitor-datasource',
  'grafana-bigquery-datasource',
  'grafana-clickhouse-datasource',
  'grafana-databricks-datasource',
  'grafana-datadog-datasource',
  'grafana-dynatrace-datasource',
  'grafana-es-open-distro-datasource',
  'grafana-falconlogscale-datasource',
  'grafana-github-datasource',
  'grafana-gitlab-datasource',
  'grafana-honeycomb-datasource',
  'grafana-iot-sitewise-datasource',
  'grafana-jira-datasource',
  'grafana-looker-datasource',
  'grafana-mock-datasource',
  'grafana-mongodb-datasource',
  'grafana-newrelic-datasource',
  'grafana-odbc-datasource',
  'grafana-opcua-datasource',
  'grafana-opensearch-datasource',
  'grafana-oracle-datasource',
  'grafana-orbit-datasource',
  'grafana-redshift-datasource',
  'grafana-salesforce-datasource',
  'grafana-saphana-datasource',
  'grafana-sentry-datasource',
  'grafana-servicenow-datasource',
  'grafana-snowflake-datasource',
  'grafana-splunk-datasource',
  'grafana-splunk-monitoring-datasource',
  'grafana-sumologic-datasource',
  'grafana-testdata-datasource',
  'grafana-timestream-datasource',
  'grafana-wavefront-datasource',
  'grafana-x-ray-datasource',
  'graphite',
  'hadesarchitect-cassandra-datasource',
  'influxdata-flightsql-datasource',
  'influxdb',
  'innius-grpc-datasource',
  'kniepdennis-neo4j-datasource',
  'loki',
  'manassehzhou-maxcompute-datasource',
  'marcusolsson-csv-datasource',
  'mssql',
  'mysql',
  'nagasudhirpulla-api-datasource',
  'needleinajaystack-haystack-datasource',
  'opentsdb',
  'postgres',
  'prometheus',
  'quickwit-quickwit-datasource',
  'redis-datasource',
  'sentinelone-dataset-datasource',
  'sneller-sneller-datasource',
  'spiceai-spicexyz-datasource',
  'stackdriver',
  'tdengine-datasource',
  'trino-datasource',
  'vertamedia-clickhouse-datasource',
  'vertica-grafana-datasource',
  'ydbtech-ydb-datasource',
  'yesoreyeram-infinity-datasource',
]);
